<template>
  <v-dialog eager v-model="dialog" max-width="280">
    <v-card class="primary">
      <!-- title -->
      <div class="primary white--text pt-2 px-2 d-flex align-center">
        <!-- migliore offerta -->
        <squadra-offerta
          v-if="mode_poker || mode_selvaggia"
          :offerta="migliore_offerta.offerta"
          :uid="migliore_offerta.vincitore"
          class="ml-2 mt-2"
          variant="horizontal"
          creditiGlow
        ></squadra-offerta>
        <v-spacer></v-spacer>
        <v-btn depressed icon @click="dismiss()">
          <v-icon>close</v-icon>
        </v-btn>
      </div>

      <!-- mia offerta -->
      <!-- <div class="white--text text-h5 text-center">La mia offerta</div> -->
      <div
        class="
          primary--text
          text--darken-3 text-center text-h4
          font-weight-black
          mt-2
        "
        style="height: 35px"
      >
        <span v-if="value">{{ value }}</span>
        <span v-else>-</span>
      </div>

      <v-container>
        <v-row no-gutters class="text-center">
          <!-- tastierino 1-9 -->
          <v-col cols="4" v-for="i in 9" :key="i">
            <v-btn depressed class="primary white--text" @click="insert(i)">{{
              i
            }}</v-btn>
          </v-col>

          <!-- canc 0 back -->
          <v-col cols="4">
            <v-btn text class="white--text" @click="clear()">CANC</v-btn>
          </v-col>
          <v-col cols="4">
            <v-btn
              large
              depressed
              class="primary white--text"
              @click="insert(0)"
              >0</v-btn
            >
          </v-col>
          <v-col cols="4">
            <v-btn text class="white--text" @click="backspace()">
              <v-icon>backspace</v-icon>
            </v-btn>
          </v-col>

          <!-- invia -->
          <v-col cols="12" class="mt-2">
            <v-btn rounded large block color="secondary" @click="setOfferta()"
              >INVIA</v-btn
            ></v-col
          >
        </v-row>
      </v-container>
      <div v-if="error" class="px-2 error white--text text-center">
        Offerta {{ errorValue }} non valida.<br />
        Min: {{ minOfferta }} - Max: {{ maxOfferta }}
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import SquadraOfferta from "../common/SquadraOfferta";
import Constants from "../../js/constants";
import * as Helpers from "../../js/helpers";
import mixins from "../../js/mixins";
import Vuex from "vuex";
import db from "../../js/db";

export default {
  mixins: [mixins],
  components: {
    SquadraOfferta,
  },
  mounted() {
    console.log("--> AstaNumpad ready.");
    db.on("numpad", this.handleVisibility);
  },
  destroyed() {
    console.log("<-- AstaNumpad destroyed.");
    db.off("numpad", this.handleVisibility);
  },
  data() {
    return {
      value: "",
      dialog: false,
      error: false,
      processing: false,
      errorValue: 0,
      options: null,
    };
  },
  methods: {
    handleVisibility(val) {
      if (val) {
        this.show(typeof val == "object" ? val : null);
      } else {
        this.dismiss();
      }
    },
    keyup(e) {
      switch (e.keyCode) {
        case 13:
          this.setOfferta();
          break;
        case 8:
          this.backspace();
          break;
        case 46:
          this.clear();
          break;
        case 48:
        case 96:
          this.insert(0);
          break;
        case 49:
        case 97:
          this.insert(1);
          break;
        case 50:
        case 98:
          this.insert(2);
          break;
        case 51:
        case 99:
          this.insert(3);
          break;
        case 52:
        case 100:
          this.insert(4);
          break;
        case 53:
        case 101:
          this.insert(5);
          break;
        case 54:
        case 102:
          this.insert(6);
          break;
        case 55:
        case 103:
          this.insert(7);
          break;
        case 56:
        case 104:
          this.insert(8);
          break;
        case 57:
        case 105:
          this.insert(9);
          break;
        default:
          break;
      }
    },
    squadra(id) {
      return this.asta_squadre[id];
    },
    show(options = null) {
      this.options = options;
      this.dialog = true;
      this.value =
        options && options.value !== undefined && options.value !== null
          ? options.value.toString()
          : "";
      this.error = false;
    },
    dismiss() {
      this.dialog = false;
      this.options = null;
    },
    insert(i) {
      this.value = this.value.concat(i);
      this.error = false;
    },
    clear() {
      this.value = "";
    },
    backspace() {
      this.value = this.value.slice(0, -1);
    },
    async setOfferta() {
      if (this.processing) {
        console.log("processing");
        return;
      }
      this.processing = true;

      // check min-max offerta
      let value = parseFloat(this.value);
      if (isNaN(value) || value > this.maxOfferta || value < this.minOfferta) {
        this.error = true;
        this.processing = false;
        this.errorValue = value;
        this.clear();
        return;
      }

      let confirmSubmit = true;

      // in caso di poker, controlliamo nn si stia offrendo + di 30
      if (
        this.mode_poker &&
        parseFloat(this.value) - this.migliore_offerta.offerta >= 30
      ) {
        await Swal.fire({
          title: "Sei sicuro?",
          text: "Rilancio supera i 30 crediti",
          icon: "warning",
          showCancelButton: true,
        }).then((result) => {
          if (result.isConfirmed == false) {
            confirmSubmit = false;
          }
        });
      }

      // in caso di busta chiusa, chiediamo conferma
      if (this.mode_bustachiusa) {
        await Swal.fire({
          title: "Confermi offerta di " + value + "?",
          text: "Non potrai annullare l'operazione",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Invia Busta",
          cancelButtonText: "Annulla",
        }).then((result) => {
          if (result.isConfirmed == false) {
            confirmSubmit = false;
          }
        });
      }

      // submit
      if (confirmSubmit) {
        db.emit("numpadSubmitted", value);
        this.dismiss();
      }

      // in qualcunque caso
      this.processing = false;
    },
  },
  computed: {
    maxOfferta() {
      // se la massima offerta é passata al numpad usa quella...
      if (this.options && this.options.max !== undefined) {
        return this.options.max;
      }
      // se nn e´passata invece usa quella della squadra dell utente se esiste.
      // altrimenti, come ultima possibilitá ritorna l offerta minima configurata per questa asta (ma é giusto?)
      return this.squadra(this.user_uid)
        ? this.squadra(this.user_uid).max_offerta
        : Constants.OFFERTA.MINIMA;
    },
    minOfferta() {
      // se la minima offerta e´passata al numpad, passa quella
      if (this.options && this.options.min !== undefined) {
        return this.options.min;
      }
      // altrimenti....
      if (this.mode_bustachiusa) {
        return this.asta_round.step && this.asta_round.step.min_offerta
          ? this.asta_round.step.min_offerta
          : Helpers.minOfferta(
              this.asta_settings.base_asta,
              this.calciatore(this.asta_round.calciatoreInAsta)
            );
      } else {
        return this.migliore_offerta.vincitore
          ? this.migliore_offerta.offerta + Constants.OFFERTA.MINIMA
          : Helpers.minOfferta(
              this.asta_settings.base_asta,
              this.calciatore(this.asta_round.calciatoreInAsta)
            );
      }
    },
    ...Vuex.mapGetters(["migliore_offerta"]),
  },
  watch: {
    dialog: function (val) {
      if (val) {
        window.addEventListener("keyup", this.keyup);
      } else {
        window.removeEventListener("keyup", this.keyup);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
